import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector, FormSection } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import { formSettings } from '../settings';
import { TextField, PhoneField } from '../../../../../../components/fields';
import { required } from '../../../../../../utilities/validation';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { saveAddress, getAddresses } from '../../../../../../reducers/addresses';
import { setProgressionProperties } from '../../../../../../reducers/onboarding';
import { updateUserDetails, updateUserProfile } from '../../../../../../reducers/identity';
import { setJobProgress } from '../../../../../../reducers/jobs';
import { setProgress } from '../../../../../../reducers/wizard';
import AddressComponent from '../../../../../../components/address';

import mixpanel from 'mixpanel-browser';
import { taxFields } from '../../../../../../utilities/regime';
class WelcomeBackStep extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'ic', step: 'WelcomeBackStep' } });

        const { role, getAddresses, setProgressionProperties, setProgress, job } = this.props;
        setProgress({ entity: 'job', id: job.id }, { ...job.progress, step: -1 });

        if (job.progress.step < 0) {
            getAddresses(role, addresses => {
                if (addresses && addresses.length > 0) {
                    setProgressionProperties({ mailingAddress: addresses[0] });
                }
            });
            setProgress({ entity: 'job', id: job.id }, { ...job.progress, step: 0 });
        }
    }

    submit(values, action) {
        const { role, details, profile, updateUserDetails, updateUserProfile, saveAddress, setProgressionProperties, address } = this.props;
        const { company, mailingAddress } = values;

        updateUserDetails(role, { ...details, ...company }, () => {
            updateUserProfile({ ...profile, phone: company.phone }, () =>
                saveAddress({ ...address, ...mailingAddress, ref_type: role.type, ref_id: role.id }, () => {
                    setProgressionProperties({ mailingAddress: mailingAddress });
                    action();
                })
            );
        });
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, progression, businessType, client, regime } = this.props;
        if (!progression) {
            return null;
        }

        return (
            <div>
                <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                    <div className="row section">
                        <div className="col-sm-9 col-xs-12">
                            <FormattedMessage
                                id={'onboarding.welcomeBack'}
                                defaultMessage={
                                    'Here’s the information you gave us already.  If it’s all correct, then we can proceed to your independent contractor agreement and W-9 certification.'
                                }
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-9 col-xs-12">
                            <div className="row">
                                {taxFields(regime, businessType)}
                                <div className="col-md-8 col-sm-7 col-xs-12">
                                    <Field name="company.name" validate={required} component={TextField} placeholder={messages.businessName} />
                                </div>
                                <div className="col-md-4 col-sm-5 col-xs-12">
                                    <Field name="company.phone" validate={required} component={PhoneField} placeholder={messages.phoneNumber} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <FormattedMessage {...messages.businessAddress} tagName={'h5'} />
                        </div>
                        <div className="col-sm-9 col-xs-12">
                            <FormSection name={'mailingAddress'}>
                                <div className="row">
                                    <AddressComponent
                                        disabledFields={['country']}
                                        form={formSettings.form}
                                        section={'mailingAddress'}
                                        hideName={true}
                                        countries={client.countries}
                                        oneLineAddress={true}
                                    />
                                </div>
                            </FormSection>
                        </div>
                    </div>

                    <WizardButtons disabled={submitting} back={{ action: back }} />
                </form>
            </div>
        );
    }
}

WelcomeBackStep = reduxForm(formSettings)(WelcomeBackStep);

const selector = formValueSelector('contractor-onboarding-wizard');
const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    let details = state.identity.details;
    return {
        role: state.identity.role,
        businessType: selector(state, 'company.business_type') ? selector(state, 'company.business_type') : '',
        details,
        profile: state.identity.profile,
        client: state.onboarding.client,
        progression,
        address: (state.addresses.list || [{}])[0],
        initialValues: {
            company: details,
            mailingAddress: progression ? progression.mailingAddress : undefined
        }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateUserDetails,
            updateUserProfile,
            setJobProgress,
            saveAddress,
            getAddresses,
            setProgressionProperties,
            setProgress
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeBackStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/contractor/welcomeBack.jsx